<template>
    <va-edit-layout>
        <SAFETReimbursementEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></SAFETReimbursementEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
